import { mutationOptions } from "@tanstack/react-query";
import { postAPI } from "../../../../api/ApiHelpers.ts";

type TopupPayload = {
  tokens_added: number;
  validity_days: number;
  flat_fee: number;
  name?: string;
};

type TopupParams = {
  slug: string;
  payload: TopupPayload;
};

export const postWalletTopup = async ({ slug, payload }: TopupParams) => {
  console.log(slug)
  const response = await postAPI("wallet/topup", payload, slug);
  return response;
};

const createWalletTopupMutation = (slug: string) =>
  mutationOptions({
    mutationKey: ["walletTopup", slug],
    mutationFn: (payload: TopupPayload) => postWalletTopup({ slug, payload }),
  });

export default createWalletTopupMutation;
